import { api } from '@ai/common/src/api/axios';
import { TariffPlan, TariffPlanPostForm } from '@type/tariffPlan';

class TariffPlanService {
  private baseUrl = '/platform/api/v1/tariff_plan';

  getList = async () => await api.get<TariffPlan[]>(`${this.baseUrl}`);

  create = async ({ name, voice_responses, text_responses, price }: TariffPlanPostForm) =>
    await api.postForm<TariffPlan>(this.baseUrl, {
      name,
      voice_responses,
      text_responses,
      price,
    });
}

export const tariffPlanService = new TariffPlanService();
